import React, { useState, useEffect } from "react";
import CssCodeEditor from "../../../components/CssCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const AppearanceTab = ({ handleLayoutChange, selectedLayout,updateFaqTabData,faqTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [templateType, setTemplateType] = useState(faqTabData.template_type);
    const [templateTypeDropdownOpen, setTemplateTypeDropdownOpen] = useState(false);
    const [itemBackgroundColor, setItemBackgroundColor] = useState(faqTabData.item_background_color);
    const [answerTextColor, setAnswerTextColor] = useState(faqTabData.answer_text_color);
    const [questionTextColor, setQuestionTextColor] = useState(faqTabData.question_text_color);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(faqTabData.custom_css);

    // Handlers Template Type Change
    const handleTemplateTypeChange = (type) => {
        setTemplateType(type);
        updateFaqTabData("template_type", type);
        setTemplateTypeDropdownOpen(false); 
    };

    // Handlers Item Background Color Change
    const handleItemBackgroundColorChange = (color) => {
        setItemBackgroundColor(color.hex);
        updateFaqTabData("item_background_color", color.hex);
    };

    // Handlers Answer Text Color Change
    const handleAnswerTextColorChange = (color) => {
        setAnswerTextColor(color.hex);
        updateFaqTabData("answer_text_color", color.hex);
    };

    // Handlers Question Text Color Change
    const handleQuestionTextColorChange = (color) => {
        setQuestionTextColor(color.hex);
        updateFaqTabData("question_text_color", color.hex);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateFaqTabData("custom_css", code);
    };
    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Appearance</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Template</span>
                            <div className="color-pikr-box" onClick={() => setTemplateTypeDropdownOpen(!templateTypeDropdownOpen)}>
                                <em>{templateType}</em>
                                {templateTypeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Background"].map((type) => (
                                            <li key={type} onClick={() => handleTemplateTypeChange(type)}>
                                                {type}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Item Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={itemBackgroundColor} setColor={setItemBackgroundColor} onChangeComplete={handleItemBackgroundColorChange}/>
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Question Text Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={questionTextColor} setColor={setQuestionTextColor} onChangeComplete={handleQuestionTextColorChange}/>
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Answer Text Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={answerTextColor} setColor={setAnswerTextColor} onChangeComplete={handleAnswerTextColorChange}/>
                            </div>
                        </div>

                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 
        </div>
    );
};

export default AppearanceTab;